var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import moment from 'moment';
import Modal from 'react-bootstrap/lib/Modal';
import Button from '@/shared/components/Button';
import LoadingAnimation from '@/shared/components/LoadingAnimation';
import OkCancelModal from '@/shared/components/OkCancelModal';
import api from '@/shared/api';
import handleHttpError from '@/shared/services/HandleHttpError';
import dateFormatService from '@/shared/services/DateFormatService';
import DatePicker from '@/shared/components/input/DatePicker';
import YesNoModal from '@/shared/components/YesNoModal';
import { falseFunc } from '@/shared/utils/validationHelpers';
var messages = defineMessages({
    ConfigureBankHolidays: {
        id: 'ConfigureBankHolidays',
        defaultMessage: 'ConfigureBankHolidays',
    },
    Close: {
        id: 'Close',
        defaultMessage: 'Close',
    },
    Add: {
        id: 'Add',
        defaultMessage: 'Add',
    },
    AddHoliday: {
        id: 'AddHoliday',
        defaultMessage: 'Add holiday',
    },
    Date: {
        id: 'Date',
        defaultMessage: 'Date',
    },
    Cancel: {
        id: 'Cancel',
        defaultMessage: 'Cancel',
    },
    msgConfirmDeleteTitle: {
        id: 'msgConfirmDeleteTitle',
        defaultMessage: 'Delete?',
    },
    msgConfirmDeleteHoliday: {
        id: 'msgConfirmDeleteHoliday',
        defaultMessage: 'Are you sure you want to delete bank holiday {date}?',
    },
});
var AddHolidayModal = function (_a) {
    var show = _a.show, onClose = _a.onClose, onSave = _a.onSave, companyId = _a.companyId;
    var intl = useIntl();
    var _b = useState(null), date = _b[0], setDate = _b[1];
    var _c = useState(false), dateFocused = _c[0], setDateFocused = _c[1];
    var _d = useState(false), saving = _d[0], setSaving = _d[1];
    var handleSave = function () { return __awaiter(void 0, void 0, void 0, function () {
        var formattedDate, response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!date)
                        return [2 /*return*/];
                    setSaving(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    formattedDate = date.utc().format('YYYY-MM-DD');
                    return [4 /*yield*/, api.base.post('/api/companyholiday', {
                            companyId: companyId,
                            date: formattedDate,
                        })];
                case 2:
                    response = _a.sent();
                    onSave(response.data);
                    setDate(null);
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    handleHttpError(intl)(error_1);
                    return [3 /*break*/, 5];
                case 4:
                    setSaving(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return (_jsx(OkCancelModal, __assign({ title: intl.formatMessage(messages.AddHoliday), show: show, onClose: onClose, onSave: handleSave, disabled: saving || !date, disableFullScreen: true }, { children: _jsx("div", __assign({ className: "form-horizontal", role: "form" }, { children: _jsxs("div", __assign({ className: "form-group" }, { children: [_jsx("label", __assign({ htmlFor: "holidayDate", className: "col-sm-4 control-label" }, { children: intl.formatMessage(messages.Date) })), _jsx("div", __assign({ className: "col-sm-8" }, { children: _jsx(DatePicker, { id: "holidayDate", date: date, placeholder: intl.formatMessage(messages.Date), isOutsideRange: falseFunc, onDateChange: function (d) { return setDate(d); }, focused: dateFocused, onFocusChange: function (_a) {
                                var focused = _a.focused;
                                return setDateFocused(focused);
                            } }) }))] })) })) })));
};
var CompanyHolidaysModal = function (_a) {
    var show = _a.show, onClose = _a.onClose, companyId = _a.companyId;
    var intl = useIntl();
    var currentYear = moment.utc().year();
    var years = [currentYear - 1, currentYear, currentYear + 1, currentYear + 2];
    var _b = useState(currentYear), year = _b[0], setYear = _b[1];
    var _c = useState([]), holidays = _c[0], setHolidays = _c[1];
    var _d = useState(false), loading = _d[0], setLoading = _d[1];
    var _e = useState(false), showAddModal = _e[0], setShowAddModal = _e[1];
    var _f = useState(null), holidayToDelete = _f[0], setHolidayToDelete = _f[1];
    var loadHolidays = function (y) {
        setLoading(true);
        api.base
            .get("/api/companyholiday/".concat(companyId, "/").concat(y))
            .then(function (_a) {
            var data = _a.data;
            setHolidays(data);
        })
            .catch(handleHttpError(intl))
            .finally(function () { return setLoading(false); });
    };
    useEffect(function () {
        if (!show)
            return;
        loadHolidays(year);
    }, [show, companyId]);
    var handleYearChange = function (y) {
        setYear(y);
        loadHolidays(y);
    };
    var handleHolidayAdded = function (newHolidays) {
        setHolidays(newHolidays);
        setShowAddModal(false);
    };
    var handleDeleteConfirm = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!holidayToDelete)
                        return [2 /*return*/];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, api.base.delete("/api/companyholiday/".concat(holidayToDelete.id))];
                case 2:
                    _a.sent();
                    setHolidays(function (prev) { return prev.filter(function (h) { return h.id !== holidayToDelete.id; }); });
                    return [3 /*break*/, 5];
                case 3:
                    error_2 = _a.sent();
                    handleHttpError(intl)(error_2);
                    return [3 /*break*/, 5];
                case 4:
                    setHolidayToDelete(null);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(_Fragment, { children: [_jsxs(Modal, __assign({ show: show, onHide: onClose, enforceFocus: false, backdrop: "static" }, { children: [_jsx(Modal.Header, __assign({ closeButton: true }, { children: _jsx(Modal.Title, { children: intl.formatMessage(messages.ConfigureBankHolidays) }) })), _jsxs(Modal.Body, { children: [_jsx("select", __assign({ className: "margin10B", value: year, onChange: function (e) { return handleYearChange(Number(e.target.value)); } }, { children: years.map(function (y) { return (_jsx("option", __assign({ value: y }, { children: y }), y)); }) })), loading ? (_jsx(LoadingAnimation, {})) : (_jsx("table", __assign({ className: "table table-condensed table-striped-tbody table-hover" }, { children: _jsx("tbody", { children: holidays.map(function (holiday) { return (_jsxs("tr", { children: [_jsx("td", { children: _jsx("span", { children: dateFormatService.formatDateInFull(holiday.date) }) }), _jsx("td", { children: _jsx("i", { className: "fa fa-trash-o clickable", onClick: function () { return setHolidayToDelete(holiday); } }) })] }, holiday.id)); }) }) }))), _jsxs("button", __assign({ className: "btn btn-sm btn-inverse margin5T", onClick: function () { return setShowAddModal(true); } }, { children: [_jsx("i", { className: "fa fa-plus" }), _jsx("span", __assign({ className: "margin5L" }, { children: intl.formatMessage(messages.Add) }))] }))] }), _jsx(Modal.Footer, { children: _jsx(Button, __assign({ onClick: onClose, name: "CompanyHolidays-Close" }, { children: intl.formatMessage(messages.Close) })) })] })), _jsx(AddHolidayModal, { show: showAddModal, onClose: function () { return setShowAddModal(false); }, onSave: handleHolidayAdded, companyId: companyId }), _jsx(YesNoModal, { show: !!holidayToDelete, title: intl.formatMessage(messages.msgConfirmDeleteTitle), message: intl.formatMessage(messages.msgConfirmDeleteHoliday, {
                    date: holidayToDelete ? dateFormatService.formatDateInFull(holidayToDelete.date) : '',
                }), onSave: handleDeleteConfirm, onNo: function () { return setHolidayToDelete(null); } })] }));
};
export default CompanyHolidaysModal;
